import { render } from "./imageAssetList.vue?vue&type=template&id=4cccd542"
import script from "./imageAssetList.vue?vue&type=script&lang=js"
export * from "./imageAssetList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__